import { Box, Typography } from "@mui/material";
import React from "react";
import IActivityLogEntry from "../interface/iActivityLogEntry";
import describeActivityLogDetails from "../functions/describeActivityLogDetails";

const ActivityLogDetails = ({
  entry,
}: {
  entry: IActivityLogEntry;
}): React.JSX.Element => {
  const rows = describeActivityLogDetails(entry);

  if (rows.length === 0) {
    return <Typography variant="body2">Keine weiteren Angaben.</Typography>;
  }

  return (
    <Box
      component="dl"
      sx={{
        display: "grid",
        gridTemplateColumns: "max-content 1fr",
        columnGap: 2,
        rowGap: 0.5,
        m: 0,
        wordBreak: "break-word",
      }}
    >
      {rows.map((row, index) => (
        <React.Fragment key={`${row.label}-${index}`}>
          <Typography component="dt" variant="body2" sx={{ fontWeight: 600 }}>
            {row.label}
          </Typography>
          <Typography component="dd" variant="body2" sx={{ m: 0 }}>
            {row.value}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default ActivityLogDetails;
